import { AudioTrack, LocalTrack, VideoTrack } from "twilio-video";

/**
 * @param trackName Nome do track desejado
 * @param tracks Lista de tracks onde deverá buscar
 * @returns Track com nome igual ao passado por parâmetro
 */
export const getTrack = (
  trackName: "camera" | "microphone" | "screen",
  tracks: (VideoTrack | AudioTrack)[]
): VideoTrack | AudioTrack | LocalTrack | null => {
  let track: VideoTrack | AudioTrack | null = null;

  for (const item of tracks) {
    if (item && item.name.startsWith(trackName)) {
      track = item;
    }
  }

  return track;
};
